export { default as Img200 } from './processed/200/The-Story-of-God.jpg';
export { default as Img400 } from './processed/400/The-Story-of-God.jpg';
export { default as Imgthumb } from './processed/thumb/The-Story-of-God.jpg';
export { default as ImgthumbBlurSmall } from './processed/thumbBlurSmall/The-Story-of-God.jpg';
export { default as ImgthumbBlurLarge } from './processed/thumbBlurLarge/The-Story-of-God.jpg';
export const ImgData = { width: 1240, height: 720, ratio: 0.5806451612903226, orientation: 'landscape' };
export const colors = {
  "Vibrant": {
    "_rgb": [
      194,
      132,
      64
    ],
    "_population": 1675,
    "_hsl": [
      0.0871794871794872,
      0.5158730158730158,
      0.5058823529411764
    ]
  },
  "LightVibrant": {
    "_rgb": [
      236,
      173,
      101
    ],
    "_population": 101,
    "_hsl": [
      0.08888888888888889,
      0.7803468208092487,
      0.6607843137254902
    ]
  },
  "DarkVibrant": {
    "_rgb": [
      100,
      75,
      38
    ],
    "_population": 1872,
    "_hsl": [
      0.09946236559139786,
      0.4492753623188406,
      0.27058823529411763
    ]
  },
  "Muted": {
    "_rgb": [
      106,
      133,
      80
    ],
    "_population": 1974,
    "_hsl": [
      0.25157232704402516,
      0.24882629107981225,
      0.4176470588235294
    ]
  },
  "LightMuted": {
    "_rgb": [
      205,
      195,
      160
    ],
    "_population": 955,
    "_hsl": [
      0.12962962962962957,
      0.31034482758620696,
      0.7156862745098039
    ]
  },
  "DarkMuted": {
    "_rgb": [
      76,
      104,
      53
    ],
    "_population": 1415,
    "_hsl": [
      0.2581699346405229,
      0.3248407643312101,
      0.307843137254902
    ]
  }
}


// WEBPACK FOOTER //
// ./src/content/images/The-Story-of-God.js